import { useState } from 'react';

export function useControlledModal<T>() {
  const [currentAction, setCurrentAction] = useState<T | null>(null);

  return {
    currentAction,
    setCurrentAction,
  };
}
